import React from 'react';

import { ADMISSION_PROMPT_TARGET_OBJECTS } from 'constants/aiPrompts';

import EditPromptForm from '../shared/EditPromptForm';

export default function EditAdmissionPrompt() {
  return (
    <EditPromptForm
      targets={ADMISSION_PROMPT_TARGET_OBJECTS}
      promptLabel='Admission'
      backPath='/admin/admissions/prompts'
      providerGroupsOnly
    />
  );
}
